import React from 'react';
import { motion } from 'framer-motion';
import { QrCode, Tv, Users, Trophy, BarChart2, Layers } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const icons = [QrCode, Tv, Users, Trophy, BarChart2, Layers];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: 'easeOut', delay },
});

export default function Features() {
  const { t } = useLanguage();
  const f = t.features;

  return (
    <section id="features" className="py-14 md:py-20 bg-[#1F2833]" data-testid="features-section">
      <div className="section-container">
        <motion.div className="text-center mb-14" {...fadeUp()}>
          <div className="divider-gold mx-auto" />
          <h2 className="heading-lg">{f.title}</h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {f.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <motion.div key={i} className="card-dark p-7" {...fadeUp(i * 0.08)} data-testid={`feature-card-${i}`}>
                <div className="w-12 h-12 rounded-xl bg-[#0F6B49]/20 flex items-center justify-center mb-5
                  border border-[#0F6B49]/30 group-hover:bg-[#0F6B49]/30 transition-colors">
                  <Icon size={22} className="text-[#D5A63B]" />
                </div>
                <h3 className="heading-md mb-2 text-[#F3F1EB] text-lg">{item.title}</h3>
                <p className="text-[#8A9099] text-sm leading-relaxed">{item.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
